import { Checkbox, Stack } from "@mantine/core";
import React from "react";
import { useActions, useAppState } from "src/state";
import { useCalendar } from "src/components/calendar/CalendarContext";

export const OperationsAdminVenueBookingCalendarAreaFilter: React.FC<{}> = () => {

    const { itemsList, loading } = useAppState(state => state.areas)
    const getAllItems = useActions().areas.getAllItems
    const { areaFilter, setAreaFilter } = useCalendar()
    const { tenant_id: currentTenantId } = useAppState(state => state.auth)

    React.useEffect(() => {
        getAllItems({
            where: {
                venue_id: { _eq: currentTenantId }
            }
        })
    }, [])

    if (loading) return <span>Loading...</span>

    const allSelected = areaFilter.length === 0
    const someSelected = areaFilter.length > 0 && areaFilter.length < itemsList.length

    const handleAllAreaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (allSelected) {
            event.preventDefault()
        } else {
            setAreaFilter([])
        }
    }

    return (
        <Stack gap="xs">

            <Checkbox
                label="All Areas"
                checked={allSelected}
                indeterminate={someSelected}
                onChange={handleAllAreaChange}
            />

            <Stack gap="xs">
                {itemsList.map((user) => (
                    <Checkbox
                        key={user.id}
                        value={user.id}
                        label={user.name}
                        onChange={(event) => {
                            const checked = event.currentTarget.checked
                            if (checked) {
                                setAreaFilter(areaFilter.filter(id => id !== user.id))
                            } else {
                                if (areaFilter.length !== itemsList.length - 1) {
                                    setAreaFilter([...areaFilter, user.id])
                                }
                            }
                        }}
                        checked={allSelected ? true : !areaFilter.includes(user.id)}
                    />
                ))}
            </Stack>

        </Stack>
    )

}